// extracted by mini-css-extract-plugin
export var brand = "_6e-9";
export var compact = "_6e-6";
export var extraSmall = "_6e-7";
export var icon = "_6e-0";
export var large = "_6e-4";
export var light = "_6e-1";
export var medium = "_6e-5";
export var outline = "_6e-b";
export var primaryDark = "_6e-a";
export var primaryLight = "_6e-8";
export var primaryModern = "_6e-c";
export var success = "_6e-2";
export var successSolid = "_6e-3";